var map = {
	"./AddQualificationModal/AddQualificationModal": 212,
	"./AddQualificationModal/AddQualificationModal.jsx": 212,
	"./AddQualificationModal/Main": 923,
	"./AddQualificationModal/Main.jsx": 923,
	"./AdminHomepage/HeroTest": 925,
	"./AdminHomepage/HeroTest.jsx": 925,
	"./AdminHomepage/Main": 926,
	"./AdminHomepage/Main.jsx": 926,
	"./AdminHomepage/MainContent": 213,
	"./AdminHomepage/MainContent.jsx": 213,
	"./AdminHomepage/Sidebar": 220,
	"./AdminHomepage/Sidebar.jsx": 220,
	"./AvatarUploaderForm/Main": 1497,
	"./AvatarUploaderForm/Main.jsx": 1497,
	"./ChannelDesign/Home": 275,
	"./ChannelDesign/Home.jsx": 275,
	"./ChannelDesign/HomepageSettings": 222,
	"./ChannelDesign/HomepageSettings.jsx": 222,
	"./Discussions/HomepageContainer": 927,
	"./Discussions/HomepageContainer.jsx": 927,
	"./Home/ArticleCard": 81,
	"./Home/ArticleCard.jsx": 81,
	"./Home/CureusUCard": 83,
	"./Home/CureusUCard.jsx": 83,
	"./Home/CureusUpdates": 221,
	"./Home/CureusUpdates.jsx": 221,
	"./Home/CureusUpdatesHistoryTable": 929,
	"./Home/CureusUpdatesHistoryTable.jsx": 929,
	"./Home/FeaturedContent": 217,
	"./Home/FeaturedContent.jsx": 217,
	"./Home/FeaturedContentCard": 218,
	"./Home/FeaturedContentCard.jsx": 218,
	"./Home/FeaturedContentCarousel": 930,
	"./Home/FeaturedContentCarousel.jsx": 930,
	"./Home/FeaturedContentModal": 219,
	"./Home/FeaturedContentModal.jsx": 219,
	"./Home/MetricsCard": 80,
	"./Home/MetricsCard.jsx": 80,
	"./Home/NewsCard": 82,
	"./Home/NewsCard.jsx": 82,
	"./Home/Search": 931,
	"./Home/Search.jsx": 931,
	"./Home/VideoImage": 932,
	"./Home/VideoImage.jsx": 932,
	"./Home/VideoModal": 223,
	"./Home/VideoModal.jsx": 223,
	"./HomepageFeaturedArticles/Card": 359,
	"./HomepageFeaturedArticles/Card.jsx": 359,
	"./HomepageFeaturedArticles/Content": 224,
	"./HomepageFeaturedArticles/Content.jsx": 224,
	"./HomepageFeaturedArticles/Main": 933,
	"./HomepageFeaturedArticles/Main.jsx": 933,
	"./HomepageHeros": 934,
	"./HomepageHeros.js": 934,
	"./HomepageHeros/DeleteHeroModal": 216,
	"./HomepageHeros/DeleteHeroModal.jsx": 216,
	"./HomepageHeros/Hero": 215,
	"./HomepageHeros/Hero.jsx": 215,
	"./HomepageHeros/Main": 214,
	"./HomepageHeros/Main.jsx": 214,
	"./HomepageV2/Discussions/Main": 935,
	"./HomepageV2/Discussions/Main.jsx": 935,
	"./HomepageV2/Discussions/NewDiscussionCard": 225,
	"./HomepageV2/Discussions/NewDiscussionCard.jsx": 225,
	"./HomepageV2/FeaturedMultiMedia/Main": 936,
	"./HomepageV2/FeaturedMultiMedia/Main.jsx": 936,
	"./HomepageV2Carousel/HomepageCarousel": 937,
	"./HomepageV2Carousel/HomepageCarousel.jsx": 937,
	"./HomepageV2Carousel/Slide": 226,
	"./HomepageV2Carousel/Slide.jsx": 226,
	"./NewReviewsDashboard/DashboardKeywordTool": 165,
	"./NewReviewsDashboard/DashboardKeywordTool.jsx": 165,
	"./NewReviewsDashboard/InfoWidget": 249,
	"./NewReviewsDashboard/InfoWidget.jsx": 249,
	"./NewReviewsDashboard/KeywordAutoSuggester": 455,
	"./NewReviewsDashboard/KeywordAutoSuggester.jsx": 455,
	"./NewReviewsDashboard/Main": 1512,
	"./NewReviewsDashboard/Main.jsx": 1512,
	"./NewReviewsDashboard/Reviewership": 456,
	"./NewReviewsDashboard/Reviewership.jsx": 456,
	"./NotificationsCenter/ApprovalEditorOneMatchModal": 140,
	"./NotificationsCenter/ApprovalEditorOneMatchModal.jsx": 140,
	"./NotificationsCenter/ApprovalEditorResubmittedModal": 141,
	"./NotificationsCenter/ApprovalEditorResubmittedModal.jsx": 141,
	"./NotificationsCenter/AuthorStaleReviewsCompleteModal": 142,
	"./NotificationsCenter/AuthorStaleReviewsCompleteModal.jsx": 142,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal": 143,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal.jsx": 143,
	"./NotificationsCenter/CollectionApplicationApprovalModal": 144,
	"./NotificationsCenter/CollectionApplicationApprovalModal.jsx": 144,
	"./NotificationsCenter/DraftReadyForSubmissionModal": 145,
	"./NotificationsCenter/DraftReadyForSubmissionModal.jsx": 145,
	"./NotificationsCenter/GuestEditorModal": 146,
	"./NotificationsCenter/GuestEditorModal.jsx": 146,
	"./NotificationsCenter/Main": 147,
	"./NotificationsCenter/Main.jsx": 147,
	"./NotificationsCenter/ReferralProgramModal": 148,
	"./NotificationsCenter/ReferralProgramModal.jsx": 148,
	"./NotificationsCenter/ReviewerModal": 149,
	"./NotificationsCenter/ReviewerModal.jsx": 149,
	"./PicturePrognosisHome/AnswerBarRow": 104,
	"./PicturePrognosisHome/AnswerBarRow.jsx": 104,
	"./PicturePrognosisHome/AnswerOption": 227,
	"./PicturePrognosisHome/AnswerOption.jsx": 227,
	"./PicturePrognosisHome/AnswerOutcome": 228,
	"./PicturePrognosisHome/AnswerOutcome.jsx": 228,
	"./PicturePrognosisHome/Clarification": 229,
	"./PicturePrognosisHome/Clarification.jsx": 229,
	"./PicturePrognosisHome/Landing": 938,
	"./PicturePrognosisHome/Landing.jsx": 938,
	"./PicturePrognosisHome/Widget": 276,
	"./PicturePrognosisHome/Widget.jsx": 276,
	"./UserProfile": 1519,
	"./UserProfile.js": 1519,
	"./UserProfile/Biography": 1520,
	"./UserProfile/Biography.jsx": 1520,
	"./UserProfile/ContentCard": 277,
	"./UserProfile/ContentCard.jsx": 277,
	"./UserProfile/Main": 1521,
	"./UserProfile/Main.jsx": 1521,
	"./UserProfile/SiqHover": 1522,
	"./UserProfile/SiqHover.jsx": 1522,
	"./UserProfileModals": 1523,
	"./UserProfileModals.js": 1523,
	"./UserProfileModals/AffiliationsMain": 461,
	"./UserProfileModals/AffiliationsMain.jsx": 461,
	"./UserProfileModals/AffiliationsRow": 462,
	"./UserProfileModals/AffiliationsRow.jsx": 462,
	"./UserProfileModals/EditAboutMe": 463,
	"./UserProfileModals/EditAboutMe.jsx": 463,
	"./UserProfileModals/EditInstitutionalEmail": 464,
	"./UserProfileModals/EditInstitutionalEmail.jsx": 464,
	"./UserProfileModals/EditProfile": 465,
	"./UserProfileModals/EditProfile.jsx": 465,
	"./UserProfileModals/Main": 1524,
	"./UserProfileModals/Main.jsx": 1524,
	"./UserProfileModals/Npi": 467,
	"./UserProfileModals/Npi.jsx": 467,
	"./UserProfileModals/NpiEdit": 468,
	"./UserProfileModals/NpiEdit.jsx": 468,
	"./UserProfileModals/NpiOther": 469,
	"./UserProfileModals/NpiOther.jsx": 469,
	"./UserProfileModals/NpiRegistered": 471,
	"./UserProfileModals/NpiRegistered.jsx": 471,
	"./UserProfileModals/NpiRows": 206,
	"./UserProfileModals/NpiRows.jsx": 206,
	"./UserProfileModals/NpiUs": 470,
	"./UserProfileModals/NpiUs.jsx": 470,
	"./UserProfileModals/PeerReviewPanel": 472,
	"./UserProfileModals/PeerReviewPanel.jsx": 472,
	"./UserProfileModals/PhoneNumber": 466,
	"./UserProfileModals/PhoneNumber.jsx": 466,
	"./UserProfileModals/PublicProfile": 473,
	"./UserProfileModals/PublicProfile.jsx": 473,
	"./UsersPage/Activities": 1525,
	"./UsersPage/Activities.jsx": 1525,
	"./UsersPage/Coauthors": 1526,
	"./UsersPage/Coauthors.jsx": 1526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2205;